// extracted by mini-css-extract-plugin
export default {"reg":"styles_reg__5qSl4","body":"styles_body__13M5n","left":"styles_left__cX8av"};